import { IoPersonOutline } from "react-icons/io5";
import { BsCart3 } from "react-icons/bs";
import { PiMoney } from "react-icons/pi";
import { FiActivity } from "react-icons/fi";

function CustomerDetailTabSection({ onTabSelect, selected }) {
  const tabs = [
    {
      label: "Profile Details",
      code: "profile",
      icon: <IoPersonOutline />,
    },
    {
      label: "Orders",
      code: "order",
      icon: <BsCart3 />,
    },
    {
      label: "Transactions",
      code: "transaction",
      icon: <PiMoney />,
    },
    {
      label: "Activity logs",
      code: "log",
      icon: <FiActivity />,
    },
  ];
  return (
    <div className="w-full mt-6 bg-white shadow-md flex-shrink-0 overflow-scroll scroll-hide flex">
      {tabs?.map((tab, tabIndex) => {
        const isSelected = tab.code === selected;
        return (
          <button
            key={tabIndex}
            className={`flex flex-1 items-center flex-shrink-0 px-4 justify-center py-3 font-bold border-b-4 gap-2 ${
              isSelected
                ? "text-primary1 border-primary1"
                : "border-transparent text-[#6D7C94]"
            }`}
            onClick={() => {
              onTabSelect(tab.code);
            }}
          >
            <span>{tab.icon}</span>
            <span className="text-sm lg:text-base whitespace-nowrap">
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default CustomerDetailTabSection;
